<template>
  <div class="result-page-wrapper">
    <div class="talent-selftest-container">
      <h1 class="talent-title fontWeight">恭喜完成测试</h1>
    
    <div>
      <div class="fontDesc mb-8" style="text-align: justify;">
        <span>你最具有 </span>
        <span class="themeColor">{{ adeptAbility }}</span>， 然而
        <span class="otherColor">{{ ineffectual }}</span>相对较弱。
      </div>
      
      <div class="mb-6">
        <h2 class="text-2xl fontWeight mb-6">天赋能力图</h2>
        <div class="chart-wrapper">
          <div 
            ref="chart" 
            class="chart-container"
          ></div>
        </div>
      </div>
      
      <div>
        <h2 class="text-2xl fontWeight mb-6">各项天赋分值</h2>
        <ul>
          <li 
            v-for="item in sortedResultsArr" 
            :key="item.name"
            class="talent-item"
          >
            <span class="talent-number">{{ item.name }}.</span>
            <span class="talent-name">{{ talents[item.name].replace('天赋', '') }}:</span>
            <div class="progress-wrapper">
              <el-progress 
                :percentage="(item.value / 20) * 100"
                :show-text="false"
                :stroke-width="18"
                color="#8e53c4"
                class="talent-progress"
              />
              <span class="single-score">{{ item.value }}分</span>
            </div>
            <span class="fontWeight scope_desc">{{ displayTalentResult(item.value) }}</span>
          </li>
        </ul>
      </div>
      
      <div style="text-align: center;">
        <div class="button-group">
          <button 
            class="btn btn-secondary text-white px-4 py-2 rounded mt-8"
            @click="goHome"
          >
            返回首页
          </button>
          <button 
            class="btn text-white px-4 py-2 rounded mt-8"
            @click="handleRetest"
          >
            重新测试
          </button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { clearProgress } from '@/utils/storage'

export default {
  name: 'TestResult',
  computed: {
    results() {
      return this.$store.getters.testResults
    },
    talents() {
      return this.$store.getters.talents
    }
  },
  data() {
    return {
      abilityChart: null,
      sortedResultsArr: [],
      adeptAbility: '',
      ineffectual: ''
    }
  },
  methods: {
    goHome() {
      // 清除测试结果和进度
      this.$store.dispatch('resetTest')
      clearProgress()
      this.$router.push('/')
    },
    
    handleRetest() {
      // 清除测试结果和进度
      this.$store.dispatch('resetTest')
      clearProgress()
      this.$router.push('/')
    },
    
    displayTalentResult(score) {
      if (score >= 4 && score <= 7) return '完全不擅长'
      if (score >= 8 && score <= 11) return '不太擅长'
      if (score >= 12 && score <= 15) return '有些擅长'
      if (score >= 16 && score <= 20) return '非常擅长'
      return ''
    }
    },
    mounted() {
    // 如果没有测试结果，重定向到首页
      if (!this.results) {
        // 信息提示
      this.$message.error('测试结果不存在，请重新测试')
      this.$router.push('/')
      return
      }
      
      // 排序结果数组
      this.sortedResultsArr = Object.entries(this.results)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([name, value]) => ({ name, value }))
      
      // 销毁之前的图表实例
      if (this.abilityChart && this.abilityChart.dispose) {
        this.abilityChart.dispose()
        }
        
        // 创建雷达图
        this.abilityChart = echarts.init(this.$refs.chart)
        
        // 排序对象
        const sortedObj = Object.fromEntries(
          Object.entries(this.results).sort(([a], [b]) => a.localeCompare(b))
        )
        
        // 构建雷达图数据
        const indicator = Object.entries(sortedObj).map(([name, max]) => ({
          name: `${name}(${max}分)`,
          max: 20
        }))
        
        const values = Object.values(sortedObj)
        
        const option = {
          title: {
            text: ''
          },
          legend: {},
          grid: {
            top: 20,
            left: 20,
            right: 20,
            bottom: 20,
            containLabel: true
          },
          radar: {
            indicator: indicator,
            center: ['50%', '50%'],
            radius: '68%',
            axisName: {
              color: '#8E53C4',
              lineHeight: 20,
              borderRadius: 5,
              padding: [0, 3, 0, 3],
              backgroundColor: '#F4EFF8'
            },
            axisLine: {
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#F4EFF8'
              }
            }
          },
          series: [{
            name: 'Budget vs spending',
            type: 'radar',
            data: [{
              value: values,
              name: '',
              lineStyle: {
                color: '#8E53C4'
              }
            }],
            itemStyle: {
              normal: {
                color: '#8E53C4'
              }
            }
          }]
        }
        
        this.abilityChart.setOption(option)
        
         // 添加窗口大小变化监听，使图表响应式调整
        this.handleResize = () => {
          if (this.abilityChart) {
            this.abilityChart.resize()
          }
        }
        window.addEventListener('resize', this.handleResize)
        
        // 使用 nextTick 确保 DOM 渲染完成后再调整图表
        this.$nextTick(() => {
        if (this.abilityChart) {
          this.abilityChart.resize()
        }
      })
      
      // 计算最强和最弱的天赋
      this.adeptAbility = Object.entries(this.results)
        .sort(([, a], [, b]) => b - a)
        .map(([key]) => this.talents[key])
        .slice(0, 3)
        .join('、')
      
      this.ineffectual = Object.entries(this.results)
        .sort(([, a], [, b]) => a - b)
        .map(([key]) => this.talents[key])
        .slice(0, 3)
        .join('、')
  },
  
  beforeUnmount() {
    // 移除事件监听
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
    // 销毁图表实例
    if (this.abilityChart && this.abilityChart.dispose) {
      this.abilityChart.dispose()
    }
  }
}
</script>

<style scoped>
.result-page-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 3rem 0.8rem;
}

.talent-selftest-container {
  max-width: 600px;
  margin: 0 auto;
  background: white;
  border-radius: 10px;
  padding: 30px 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  position: relative;
}

/* 返回首页按钮样式 */
.home-link-wrapper {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
}

.home-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: rgba(142, 83, 196, 0.1);
  color: #8e53c4;
  text-decoration: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.home-link:hover {
  background: rgba(142, 83, 196, 0.2);
  transform: translateX(-3px);
}

.home-icon {
  font-size: 18px;
  font-weight: bold;
}

.home-text {
  font-size: 14px;
}

.talent-title {
  text-align: center;
  font-size: 1.75em;
  margin-bottom: 1rem;
  font-weight: 700;
}

.themeColor {
  color: #8e53c4;
  font-weight: 600;
}

.otherColor {
  color: #f28874;
  font-weight: 600;
}

.fontWeight {
  font-weight: 700;
}
.fontDesc {
  font-weight: 700;
  font-size: 16px;
}

.mb-8 {
  margin-bottom: 1rem;
}

.mb-6 {
  margin-bottom: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
  padding: 0;
  font-size: 14px;
}

.text-2xl {
  color: #333;
  font-weight: 600;
  font-size: 1.3rem;
}

.chart-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 10px;
  overflow: visible;
}

.chart-container {
  width: 100%;
  max-width: 320px;
  height: 260px;
  margin: 0 auto;
  overflow: visible;
}

.talent-item {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  gap: 5px;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.talent-number {
  flex-shrink: 0;
  width: 15px;
  font-size: 14px;
}

.talent-name {
  flex-shrink: 0;
  width: 69px;
  font-size: 14px;
  white-space: nowrap;
}

.progress-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  margin: 0 10px;
}

.talent-progress {
  width: 100%;
}

.scope_desc {
  flex-shrink: 0;
  padding-left: 5px;
  font-size: 14px;
  white-space: nowrap;
  min-width: 70px;
  text-align: right;
}

.button-group {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  background: #8e53c4;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.btn:hover {
  background: #7a47b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(142, 83, 196, 0.3);
}

.btn-secondary {
  background: #6c757d;
}

.btn-secondary:hover {
  background: #5a6268;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.text-white {
  color: white;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.rounded {
  border-radius: 1.25rem;
}

.mt-8 {
  margin-top: 2rem;
}

.single-score {
  position: absolute;
  left: 5px;
  color: #fff;
  font-size: 12px;
  top: 1px;
  pointer-events: none;
  white-space: nowrap;
}

ul {
  list-style: none;
  padding: 0;
}

@media (max-width: 640px) {
  .talent-selftest-container {
    padding: 20px 15px;
    margin: 0 0.5rem;
  }
  
  .chart-wrapper {
    padding: 0 5px;
  }
  
  .chart-container {
    max-width: 100%;
    height: 260px;
  }
  
  .talent-item {
    gap: 3px;
    font-size: 14px;
  }
  
  .talent-number {
    width: 12px;
    font-size: 13px;
  }
  
  .talent-name {
    width: 60px;
    font-size: 14px;
  }
  
  .progress-wrapper {
    max-width: 40%;
  }
  
  .scope_desc {
    font-size: 14px;
    padding-left: 3px;
  }
  
  .single-score {
    font-size: 11px;
  }
}

@media (max-width: 375px) {
  .result-page-wrapper {
    padding: 2rem 0.5rem;
  }
  
  .talent-selftest-container {
    padding: 15px 12px;
    margin: 0 0.3rem;
  }
  
  .chart-wrapper {
    padding: 0;
  }
  
  .chart-container {
    width: calc(100vw - 50px);
    max-width: 100%;
    height: 240px;
  }
  
  .talent-item {
    gap: 2px;
    font-size: 12px;
    flex-wrap: nowrap;
  }
  
  .talent-number {
    width: 10px;
    font-size: 12px;
  }
  
  .talent-name {
    width: 55px;
    font-size: 14px;
  }
  
  .progress-wrapper {
    max-width: 38%;
    min-width: 120px;
  }
  
  .scope_desc {
    font-size: 14px;
    padding-left: 2px;
    min-width: 70px;
  }
  
  .text-2xl {
    font-size: 1.5rem;
  }
  
  .fontDesc {
    font-size: 16px;
  }
}
</style>
